import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FileManagementResponse } from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class StreamingService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiSite.endsWith('/') 
      ? environment.apiSite.slice(0, -1) 
      : environment.apiSite;
  }

  // Import Creams DB
  importCreamsDB(fileName: string, photoId: number, storeName: string): Observable<string> {
    const params = { fileName, photoId, storeName };
    return this.http.get<string>(`${this.baseUrl}/api/Streaming/ImportCreamsDB`, { params });
  }

  // Import Employee DB
  importEmployeeDB(fileName: string, photoId: number, storeName: string): Observable<string> {
    const params = { fileName, photoId, storeName };
    return this.http.get<string>(`${this.baseUrl}/api/Streaming/ImportEmployeeDB`, { params });
  }

  // Import Jewellery DB
  importJewelleryDB(fileName: string, photoId: number, storeName: string): Observable<string> {
    const params = { fileName, photoId, storeName };
    return this.http.get<string>(`${this.baseUrl}/api/Streaming/ImportJewelleryDB`, { params });
  }

  // Get File Management
  getFileManagement(path: string = ''): Observable<FileManagementResponse> {
    const params = path ? { path } : {};
    return this.http.get<FileManagementResponse>(`${this.baseUrl}/api/Streaming/FileManagement`, { params });
  }

  // Download File
  downloadFile(filePath: string): Observable<Blob> {
    const params = { filePath };
    return this.http.get(`${this.baseUrl}/api/Streaming/Download`, {
      params,
      responseType: 'blob'
    });
  }

  // Create Directory
  createDirectory(directoryPath: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/Streaming/CreateDirectory`, {
      directoryPath
    });
  }

  // Upload To Directory
  uploadToDirectory(
    file: File,
    directoryPath: string,
    description: string = '',
    overwrite: boolean = false
  ): Observable<any> {
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DirectoryPath', directoryPath);
    formData.append('Description', description);
    formData.append('Overwrite', overwrite.toString());

    return this.http.post(`${this.baseUrl}/api/Streaming/UploadToDirectory`, formData);
  }

  // Delete File
  deleteFile(filePath: string): Observable<any> {
    const params = { filePath };
    return this.http.delete(`${this.baseUrl}/api/Streaming/DeleteFile`, { params });
  }

  // Get General File Management
  getGeneralFileManagement(storeName: string = '', category: string = ''): Observable<FileManagementResponse> {
    const params = { storeName, category };
    return this.http.get<FileManagementResponse>(`${this.baseUrl}/api/Streaming/api/FileManagement`, { params });
  }

  // Upload file
  uploadFile(file: File, storeName: string, category: string, description: string, name: string, id: number = 0): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('storeName', storeName);
    formData.append('category', category);
    formData.append('description', description);
    formData.append('name', name);
    formData.append('id', id.toString());

    return this.http.post(`${this.baseUrl}/api/Upload`, formData);
  }
} 